import { Button } from '@farol-ds/react'
import { useValidateOabModal } from '@jusbrasil-web/shared-validate-oab-modal'

import { LockWall } from './lock-wall'
import styles from './view-lock-wrapper.module.scss'

export interface ValidateOabTriggerProps {
  title: string
  subtitle?: string
  buttonText: string
}

export const ValidateOabTrigger = (props: ValidateOabTriggerProps) => {
  const validateOabModal = useValidateOabModal<HTMLButtonElement>({ origin: 'LOCK_OAB_MOTION' })

  return (
    <LockWall {...props}>
      <Button
        className={styles.lockWallButton}
        kind="primary"
        onClick={() => validateOabModal.setOpen(true)}
        ref={validateOabModal.metricsRef}
      >
        {props.buttonText}
      </Button>
    </LockWall>
  )
}
